import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Queries from '@api/graphql/queries';
import { connect } from 'react-redux';
import { ApplicationState } from 'reducers';
import { user_listUsers_data, user } from '@api/graphql/types';
import { Tab, Tabs } from '@components/Tab';
import UserOrderList from '../components/UserOrderList';
import UserAddresses from '../components/UserAddresses';
import LoginAsUserButton from '@components/LoginAsUserButton';
import ButtonCancel from '@components/Form/ButtonCancel';
import UserDiscountList from '../components/UserDiscountList';

type Props = {
    userId: string,
} & InjectedIntlProps & RouteComponentProps<{userId: string}>;


interface State {
    user: user_listUsers_data;
}

class UserEdit extends React.Component<Props, State> {
    public componentDidMount() {
        const variables = {
            page: 1,
            count: 1,
            filters: {id: this.props.match.params.userId},
        };

        GraphQLClient.query<user>({
            query: Queries.user,
            variables,
        }).then((response) => {
            if (response.data && response.data.listUsers) {
                const currentUser = response.data.listUsers.data[0];
                this.setState({ user: currentUser });
            }
        });
    }


    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.user.${id}` });
    }

    private renderRow(field: string, value: string | number | null) {
        return (
            <div className="row">
                <div className="col-sm-3">
                    <strong>{this.label(`${field}.title`)}</strong>
                </div>
                <div className="col-sm-9">
                    {value ? value : '---'}
                </div>
            </div>
        );
    }

    public render() {
        if (this.state && this.state.user) {
            return (
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-content">
                                <h2>Felhasználó adatlap</h2>
                                <div className="pull-right">
                                    <LoginAsUserButton id={this.state.user.id} />
                                </div>

                                <Tabs>
                                    <Tab id="default" label={this.label('tab.default')}>
                                        {this.renderRow('id', this.state.user.id)}
                                        {this.renderRow('ext_id', this.state.user.ext_id)}
                                        {this.renderRow('last_login', this.state.user.last_login)}
                                        {this.renderRow('email', this.state.user.email)}
                                        {this.renderRow('name', this.state.user.name)}
                                        {this.renderRow('telephone', this.state.user.telephone)}
                                        {this.renderRow('created_at', this.state.user.created_at)}
                                        {this.renderRow('lyoness_card_number', this.state.user.lyoness_card_number)}
                                        {this.renderRow('orders_count', this.state.user.orders_count)}
                                        {this.renderRow('orders_value_sum', this.state.user.orders_value_sum)}
                                        {this.renderRow('first_order_date', this.state.user.first_order_date)}
                                        {this.renderRow('last_order_date', this.state.user.last_order_date)}
                                    </Tab>
                                    <Tab id="addresses" label={this.label('tab.addresses')}>
                                        <UserAddresses user={this.state.user} />
                                    </Tab>
                                    <Tab id="order" label={this.label('tab.order')}>
                                        <UserOrderList id={this.state.user.id} />
                                    </Tab>
                                    <Tab id="discounts" label={this.label('tab.discounts')}>
                                        <UserDiscountList
                                            productDiscounts={this.state.user.product_discounts}
                                            shippingDiscounts={this.state.user.shipping_discounts}
                                        />
                                    </Tab>
                                </Tabs>
                                <br />
                                <div className="row">
                                    <div className="col-sm-12">
                                        <ButtonCancel onClick={() => this.props.history.goBack()} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return '...';
    }
}

const mapStateToProps = (state: ApplicationState, props: Props) => {
    const { userId } = props.match.params;
    return { userId };
};

export default compose(
    injectIntl,
    withRouter,
    connect(mapStateToProps),
)(UserEdit);



// WEBPACK FOOTER //
// ./src/modules/User/pages/UserEdit.tsx